export default {
    // A
    allTiers: 'All Tiers',

    // C
    createTier: 'Create Tier',
}

